__turbopack_context__.v({
  "spinner": "Spinner-module-scss-module__QKhw2G__spinner",
});
